import React from 'react'
import { StyledTooltip } from './Tooltip.styles'
import { theme } from '../../../tailwind.theme'

export default function Tooltip({
  placement,
  text,
  hasArrow,
  children,
  containerStyles,
  wrapperStyles,
  hidden = false
}) {
  return (
    <StyledTooltip
      placement={placement}
      text={text}
      theme={theme}
      hasArrow={hasArrow}
      style={containerStyles}
      hidden={hidden}
      wrapperStyles={wrapperStyles}
    >
      {children}
    </StyledTooltip>
  )
}
